export const SearchInput = ({
  placeholder = "",
  value = "",
  onChange,
  onSearch,
  drawerClose,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch?.(value);
      drawerClose?.();
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="search-input"
      />
      <button
        className="search-icon"
        type="button"
        onClick={() => {
          onSearch?.(value);
          drawerClose?.();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M11.2845 11.36L13.5999 13.6M12.8532 7.62663C12.8532 10.5132 10.5132 12.8533 7.62657 12.8533C4.73996 12.8533 2.3999 10.5132 2.3999 7.62663C2.3999 4.74002 4.73996 2.39996 7.62657 2.39996C10.5132 2.39996 12.8532 4.74002 12.8532 7.62663Z"
            stroke="#111111"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </svg>
      </button>
    </div>
  );
};
